import React from "react";
import Slider from "@material-ui/core/Slider";

export const rangeRenderer = (
    value,
    name,
    min,
    max,
    restrictionMin,
    restrictionMax,
    fieldUpdateHandler,
    mutable,
) => {
    const marks = [];
    if (restrictionMax && !isNaN(restrictionMax)) {
        for (let i = min; i <= Math.min(restrictionMax - 1, max); i++) {
            marks.push({
                value: i,
                label: "",
            });
        }
    }
    if (restrictionMin && !isNaN(restrictionMin)) {
        for (let i = Math.max(min, restrictionMin + 1); i <= max; i++) {
            marks.push({
                value: i,
                label: "",
            });
        }
    }
    return mutable || typeof fieldUpdateHandler === "function" ? (
        <div style={{ maxWidth: "90%", paddingTop: "12px" }}>
            <Slider
                value={value || 0}
                aria-labelledby="discrete-slider"
                valueLabelDisplay="on"
                step={marks.length > 0 ? null : 1}
                marks={marks}
                min={min}
                max={max}
                onChange={(_, value) => fieldUpdateHandler(name, value)}
            />
        </div>
    ) : value ? (
        value
    ) : (
        []
    );
};
